import axios_client from "../helpers/axios_client";
import { i18n } from "../../i18n";
import icon_hostel from "../../images/pois/icon_hostel.png";
import icon_hotel from "../../images/pois/icon_hotel.png";
import icon_pub from "../../images/pois/icon_pub.png";
import icon_motel from "../../images/pois/icon_motel.png";
import icon_bnb from "../../images/pois/icon_bnb.png";
import icon_peak from "../../images/pois/icon_peak.png";
import icon_shop from "../../images/pois/icon_shop.png";
import icon_town from "../../images/pois/icon_town.png";
import icon_water from "../../images/pois/icon_water.png";
import icon_post_office from "../../images/pois/icon_post_office.png";
import icon_medical from "../../images/pois/icon_medical.png";
import icon_shelter from "../../images/pois/icon_shelter.png";
import icon_history from "../../images/pois/icon_history.png";
import icon_campground from "../../images/pois/icon_campground.png";
import icon_viewpoint from "../../images/pois/icon_viewpoint.png";
import icon_pharmacy from "../../images/pois/icon_pharmacy.png";
import icon_fast_food from "../../images/pois/icon_fast_food.png";
import icon_bus from "../../images/pois/icon_bus.png";
import icon_information from "../../images/pois/icon_information.png";
import icon_cave from "../../images/pois/icon_cave.png";
import icon_coffee from "../../images/pois/icon_coffee.png";
import icon_ev_charging from "../../images/pois/icon_ev_charging.png";
import icon_gate from "../../images/pois/icon_gate.png";
import icon_junction from "../../images/pois/icon_junction.png";
import icon_parking from "../../images/pois/icon_parking.png";
import icon_picnic from "../../images/pois/icon_picnic.png";
import icon_playground from "../../images/pois/icon_playground.png";
import icon_restroom from "../../images/pois/icon_restroom.png";
import icon_storage from "../../images/pois/icon_storage.png";
import icon_swimming from "../../images/pois/icon_swimming.png";
import icon_wifi from "../../images/pois/icon_wifi.png";
import icon_wildlife from "../../images/pois/icon_wildlife.png";
import icon_waterfall from "../../images/pois/icon_waterfall.png";
import icon_warning from "../../images/pois/icon_warning.png";

import icon_hostel_waypoint from "../../images/pois/icon_hostel_waypoint.png";
import icon_hotel_waypoint from "../../images/pois/icon_hotel_waypoint.png";
import icon_pub_waypoint from "../../images/pois/icon_pub_waypoint.png";
import icon_motel_waypoint from "../../images/pois/icon_motel_waypoint.png";
import icon_bnb_waypoint from "../../images/pois/icon_bnb_waypoint.png";
import icon_peak_waypoint from "../../images/pois/icon_peak_waypoint.png";
import icon_shop_waypoint from "../../images/pois/icon_shop_waypoint.png";
import icon_town_waypoint from "../../images/pois/icon_town_waypoint.png";
import icon_water_waypoint from "../../images/pois/icon_water_waypoint.png";
import icon_post_office_waypoint from "../../images/pois/icon_post_office_waypoint.png";
import icon_medical_waypoint from "../../images/pois/icon_medical_waypoint.png";
import icon_shelter_waypoint from "../../images/pois/icon_shelter_waypoint.png";
import icon_history_waypoint from "../../images/pois/icon_history_waypoint.png";
import icon_campground_waypoint from "../../images/pois/icon_campground_waypoint.png";
import icon_viewpoint_waypoint from "../../images/pois/icon_viewpoint_waypoint.png";
import icon_pharmacy_waypoint from "../../images/pois/icon_pharmacy_waypoint.png";
import icon_fast_food_waypoint from "../../images/pois/icon_fast_food_waypoint.png";
import icon_custom_waypoint from "../../images/pois/icon_custom_waypoint.png";
import icon_bus_waypoint from "../../images/pois/icon_bus_waypoint.png";
import icon_information_waypoint from "../../images/pois/icon_information_waypoint.png";
import icon_cave_waypoint from "../../images/pois/icon_cave_waypoint.png";
import icon_coffee_waypoint from "../../images/pois/icon_coffee_waypoint.png";
import icon_ev_charging_waypoint from "../../images/pois/icon_ev_charging_waypoint.png";
import icon_gate_waypoint from "../../images/pois/icon_gate_waypoint.png";
import icon_junction_waypoint from "../../images/pois/icon_junction_waypoint.png";
import icon_parking_waypoint from "../../images/pois/icon_parking_waypoint.png";
import icon_picnic_waypoint from "../../images/pois/icon_picnic_waypoint.png";
import icon_playground_waypoint from "../../images/pois/icon_playground_waypoint.png";
import icon_restroom_waypoint from "../../images/pois/icon_restroom_waypoint.png";
import icon_storage_waypoint from "../../images/pois/icon_storage_waypoint.png";
import icon_swimming_waypoint from "../../images/pois/icon_swimming_waypoint.png";
import icon_wifi_waypoint from "../../images/pois/icon_wifi_waypoint.png";
import icon_wildlife_waypoint from "../../images/pois/icon_wildlife_waypoint.png";
import icon_waterfall_waypoint from "../../images/pois/icon_waterfall_waypoint.png";
import icon_warning_waypoint from "../../images/pois/icon_warning_waypoint.png";

import graph_client from "../graphql/graph_client";
import { GetAccomsByPolygon } from "../graphql/poi-graph";

import highlight_bnb from "../../images/highlights/highlight-bnb.webp";
import highlight_campground from "../../images/highlights/highlight-campsite.webp";
import highlight_history from "../../images/highlights/highlight-history.webp";
import highlight_hotel from "../../images/highlights/highlight-hotel.webp";
import highlight_hostel from "../../images/highlights/highlight-hostel.webp";
import highlight_peak from "../../images/highlights/highlight-peak.webp";
import highlight_restaurant from "../../images/highlights/highlight-restaurant.webp";
import highlight_town from "../../images/highlights/highlight-town.webp";
import highlight_shelter from "../../images/highlights/highlight-shelter.webp";
import highlight_pub from "../../images/highlights/highlight-pub.webp";
import highlight_viewpoint from "../../images/highlights/highlight-view.webp";
import highlight_bus_stop from "../../images/highlights/highlight-busstop.webp";
import highlight_transport from "../../images/highlights/highlight-transport.webp";
import highlight_shop from "../../images/highlights/highlight-shop.webp";
import highlight_water from "../../images/highlights/highlight-water.webp";
import highlight_pharmacy from "../../images/highlights/highlight-pharmacy.webp";
import highlight_healthcare from "../../images/highlights/highlight-healthcare.webp";
import highlight_postOffice from "../../images/highlights/highlight-postoffice.webp";
import highlight_fast_food from "../../images/highlights/highlight-fastfood.webp";
import highlight_osmCampsite from "../../images/highlights/highlight-osmcampsite.webp";

import placeholder_bnb from "../../images/highlights/placeholder-bnb.webp";
import placeholder_campground from "../../images/highlights/placeholder-campground.webp";
import placeholder_osmCampsite from "../../images/highlights/placeholder-osmCampsite.webp";
import placeholder_history from "../../images/highlights/placeholder-history.webp";
import placeholder_hotel from "../../images/highlights/placeholder-hotel.webp";
import placeholder_hostel from "../../images/highlights/placeholder-hostel.webp";
import placeholder_peak from "../../images/highlights/placeholder-peaks.webp";
import placeholder_restaurant from "../../images/highlights/placeholder-restaurant.webp";
import placeholder_town from "../../images/highlights/placeholder-town.webp";
import placeholder_shelter from "../../images/highlights/placeholder-shelter.webp";
import placeholder_pub from "../../images/highlights/placeholder-pub.webp";
import placeholder_viewpoint from "../../images/highlights/placeholder-viewpoint.webp";
import placeholder_transport from "../../images/highlights/placeholder-transport.webp";
import placeholder_shop from "../../images/highlights/placeholder-shops.webp";
import placeholder_water from "../../images/highlights/placeholder-water.webp";
import placeholder_pharmacy from "../../images/highlights/placeholder-pharmacy.webp";
import placeholder_healthcare from "../../images/highlights/placeholder-healthcare.webp";
import placeholder_bus_stop from "../../images/highlights/placeholder-busStops.webp";
import placeholder_fast_food from "../../images/highlights/placeholder-fastfood.webp";
import placeholder_postOffice from "../../images/highlights/placeholder-postOffice.webp";

export enum POI {
    Campground = 'campground',
    Hotel = 'hotel',
    Hostel = 'hostel',
    BnB = 'bnb',
    Motel = 'motel',

    OSMCampsites = 'osmCampsite',
    Shelter = 'shelter',
    Pub = 'pub',
    FastFood = 'fastfood',
    Viewpoint = 'viewpoint',
    TransportStation = 'transportStations',
    Shop = 'shop',
    Town = 'town',
    History = 'history',
    BusStop = 'busStops',
    PostOffice = 'postOffice',
    Peak = 'peaks',
    Pharmacy = 'pharmacy',
    Water = 'water',
    Healthcare = 'healthcare',
    Restaurant = 'restaurant',
    Other = 'other',
    Cave = 'cave',
    Coffee = 'coffee',
    EVCharging = 'evCharging',
    Gate = 'gate',
    Information = 'information',
    Junction = 'junction',
    Parking = 'parking',
    Picnic = 'picnic',
    Playground = 'playground',
    Restroom = 'restroom',
    Storage = 'storage',
    Swimming = 'swimming',
    Wifi = 'wifi',
    Wildlife = 'wildlife',
    Waterfall = 'waterfall',
    Warning = 'warning'
}

export class POIUtility {
    poi: POI;
    layerName: string;
    mvtUrl: string;
    puckIconName: string;
    waypointIconName: string;


  constructor(poi: POI) {
        this.poi = poi;
        // Compute and set the mvtUrl property upon initialization.
        this.puckIconName = this.computePuckIconName();
        this.waypointIconName = this.computeWaypointIconName();
    }

  computeWaypointIconName(): string {
    return `custom_waypoint_icon_${this.serverType()}`;
  }

    // Localised display name. Pass the translate function so the English form
    // can be resolved too (fromString matches stored English names).
    private displayName(t: (key: string) => string): string {
        switch (this.poi) {
            case POI.Campground:
                return t('utils.poi.campground');
            case POI.Hotel:
                return t('utils.poi.hotel');
            case POI.Hostel:
                return t('utils.poi.hostel');
            case POI.BnB:
                return t('utils.poi.bnb');
            case POI.Motel:
                return t('utils.poi.motel');
            case POI.OSMCampsites:
                return t('utils.poi.osm_campsites');
            case POI.Shelter:
                return t('utils.poi.shelter');
            case POI.Pub:
                return t('utils.poi.pub');
            case POI.FastFood:
                return t('utils.poi.fast_food');
            case POI.Viewpoint:
                return t('utils.poi.viewpoint');
            case POI.TransportStation:
                return t('utils.poi.transport_station');
            case POI.Shop:
                return t('utils.poi.shop');
            case POI.Town:
                return t('utils.poi.town');
            case POI.History:
                return t('utils.poi.history');
            case POI.BusStop:
                return t('utils.poi.bus_stop');
            case POI.PostOffice:
                return t('utils.poi.post_office');
            case POI.Peak:
                return t('utils.poi.peak');
            case POI.Pharmacy:
                return t('utils.poi.pharmacy');
            case POI.Water:
                return t('utils.poi.water_source');
            case POI.Healthcare:
                return t('utils.poi.healthcare');
            case POI.Restaurant:
                return t('utils.poi.restaurant');
            case POI.Other:
                return t('utils.poi.custom_waypoint');
            case POI.Cave:
                return t('utils.poi.cave');
            case POI.Coffee:
                return t('utils.poi.coffee');
            case POI.EVCharging:
                return t('utils.poi.ev_charging');
            case POI.Gate:
                return t('utils.poi.gate');
            case POI.Information:
                return t('utils.poi.information');
            case POI.Junction:
                return t('utils.poi.junction');
            case POI.Parking:
                return t('utils.poi.parking');
            case POI.Picnic:
                return t('utils.poi.picnic');
            case POI.Playground:
                return t('utils.poi.playground');
            case POI.Restroom:
                return t('utils.poi.restroom');
            case POI.Storage:
                return t('utils.poi.storage');
            case POI.Swimming:
                return t('utils.poi.swimming');
            case POI.Wifi:
                return t('utils.poi.wifi');
            case POI.Wildlife:
                return t('utils.poi.wildlife');
            case POI.Waterfall:
                return t('utils.poi.waterfall');
            case POI.Warning:
                return t('utils.poi.warning');
            default:
                throw Error('Invalid POI');
        }
    }

    prettyName(): string {
        return this.displayName((key) => i18n.global.t(key));
    }

    // The English name, independent of the reader's locale — used to parse
    // stored/legacy English type names back into a POI.
    englishName(): string {
        return this.displayName((key) => i18n.global.t(key, {}, { locale: 'en' }));
    }

    imageLayerName(): string {
        return this.poi + 'Layer-234';
    }

    serverType(): string {
        switch (this.poi) {
            case POI.Campground:
                return 'campground';
            case POI.Hotel:
                return 'hotel';
            case POI.Hostel:
                return 'hostel';
            case POI.BnB:
                return 'bnb';
            case POI.Motel:
                return 'motel';
            case POI.OSMCampsites:
                return 'osmCampsite';
            case POI.Shelter:
                return 'shelter';
            case POI.Pub:
                return 'pub';
            case POI.FastFood:
                return 'fastfood';
            case POI.Viewpoint:
                return 'viewpoint';
            case POI.TransportStation:
                return 'transportStations';
            case POI.Shop:
                return 'shop';
            case POI.Town:
                return 'town';
            case POI.History:
                return 'history';
            case POI.BusStop:
                return 'busStops';
            case POI.PostOffice:
                return 'postOffice';
            case POI.Peak:
                return 'peaks';
            case POI.Pharmacy:
                return 'pharmacy';
            case POI.Water:
                return 'water';
            case POI.Healthcare:
                return 'healthcare';
            case POI.Restaurant:
                return 'restaurant';
            case POI.Cave:
                return 'cave';
            case POI.Coffee:
                return 'coffee';
            case POI.EVCharging:
                return 'evCharging';
            case POI.Gate:
                return 'gate';
            case POI.Information:
                return 'information';
            case POI.Junction:
                return 'junction';
            case POI.Parking:
                return 'parking';
            case POI.Picnic:
                return 'picnic';
            case POI.Playground:
                return 'playground';
            case POI.Restroom:
                return 'restroom';
            case POI.Storage:
                return 'storage';
            case POI.Swimming:
                return 'swimming';
            case POI.Wifi:
                return 'wifi';
            case POI.Wildlife:
                return 'wildlife';
            case POI.Waterfall:
                return 'waterfall';
            case POI.Warning:
                return 'warning';
            case POI.Other:
                return 'other';
            default:
                throw Error('Invalid POI');
        }
    }

    hikeHighlightIcon(): any {
      switch (this.poi) {
        case POI.Campground:
            return 'highlight_icon_campground';
        case POI.Hotel:
            return 'highlight_icon_hotel';
        case POI.Hostel:
            return 'highlight_icon_hostel';
        case POI.BnB:
            return 'highlight_icon_bnb';
        case POI.Motel:
            return 'highlight_icon_motel';
        case POI.OSMCampsites:
            return 'highlight_icon_campground';
        case POI.Shelter:
            return 'highlight_icon_shelter';
        case POI.Pub:
            return 'highlight_icon_pub';
        case POI.FastFood:
            return 'highlight_icon_fastfood';
        case POI.Viewpoint:
            return 'highlight_icon_viewpoint';
        case POI.TransportStation:
            return 'highlight_icon_transport_station';
        case POI.Shop:
            return 'highlight_icon_shop';
        case POI.Town:
            return 'highlight_icon_town';
        case POI.History:
            return 'highlight_icon_history';
        case POI.BusStop:
            return 'highlight_icon_bus_stop';
        case POI.PostOffice:
            return 'highlight_icon_post_office';
        case POI.Peak:
            return 'highlight_icon_peak';

        case POI.Pharmacy:
            return 'highlight_icon_pharmacy';
        case POI.Water:
            return 'highlight_icon_water';
        case POI.Healthcare:
            return 'highlight_icon_healthcare';
        case POI.Restaurant:
            return 'highlight_icon_restaurant';
        case POI.Other:
            return 'highlight_icon_information';
        case POI.Cave:
            return 'highlight_icon_cave';
        case POI.Coffee:
            return 'highlight_icon_coffee';
        case POI.EVCharging:
            return 'highlight_icon_ev_charging';
        case POI.Gate:
            return 'highlight_icon_gate';
        case POI.Information:
            return 'highlight_icon_information';
        case POI.Junction:
            return 'highlight_icon_junction';
        case POI.Parking:
            return 'highlight_icon_parking';
        case POI.Picnic:
            return 'highlight_icon_picnic';
        case POI.Playground:
            return 'highlight_icon_playground';
        case POI.Restroom:
            return 'highlight_icon_restroom';
        case POI.Storage:
            return 'highlight_icon_storage';
        case POI.Swimming:
            return 'highlight_icon_swimming';
        case POI.Wifi:
            return 'highlight_icon_wifi';
        case POI.Wildlife:
            return 'highlight_icon_wildlife';
        case POI.Waterfall:
            return 'highlight_icon_waterfall';
        case POI.Warning:
            return 'highlight_icon_warning';
        default:
            throw Error('Invalid POI for hike highlight options: ' + this.poi);
      }
    }

  mapboxFilterType(): string {
    // Primary filter type used for localStorage persistence and toggle state.
    // For the actual tileset filter, use mapboxFilterTypes() which includes all variants.
    return this.mapboxFilterTypes()[0];
  }

  mapboxFilterTypes(): string[] {
    // All known variant strings for this POI type in the vector tileset.
    // The filter sends all variants so we match regardless of casing convention.
    switch (this.poi) {
      case POI.Campground: return ['campground'];
      case POI.Hotel: return ['hotel'];
      case POI.Hostel: return ['hostel'];
      case POI.BnB: return ['bnb'];
      case POI.Motel: return ['motel'];
      case POI.OSMCampsites: return ['osmCampsite', 'osmcampsite', 'osm_campsite', 'osm-campsite', 'osmCampsites'];
      case POI.Shelter: return ['shelter'];
      case POI.Pub: return ['pub'];
      case POI.FastFood: return ['fastfood', 'fast_food', 'fast-food'];
      case POI.Viewpoint: return ['viewpoint'];
      case POI.TransportStation: return ['transportStations', 'transportStation', 'transport_station', 'transport-station'];
      case POI.Shop: return ['shop'];
      case POI.Town: return ['town'];
      case POI.History: return ['history'];
      case POI.BusStop: return ['busStops', 'busStop', 'bus_stop', 'bus-stop', 'bus-stops'];
      case POI.PostOffice: return ['postOffice', 'post_office', 'post-office'];
      case POI.Peak: return ['peak', 'peaks'];
      case POI.Pharmacy: return ['pharmacy'];
      case POI.Water: return ['water'];
      case POI.Healthcare: return ['healthcare'];
      case POI.Restaurant: return ['restaurant'];
      case POI.Other: return ['other'];
      case POI.Cave: return ['cave'];
      case POI.Coffee: return ['coffee'];
      case POI.EVCharging: return ['evCharging', 'ev_charging', 'ev-charging'];
      case POI.Gate: return ['gate'];
      case POI.Information: return ['information'];
      case POI.Junction: return ['junction'];
      case POI.Parking: return ['parking'];
      case POI.Picnic: return ['picnic'];
      case POI.Playground: return ['playground'];
      case POI.Restroom: return ['restroom'];
      case POI.Storage: return ['storage'];
      case POI.Swimming: return ['swimming'];
      case POI.Wifi: return ['wifi'];
      case POI.Wildlife: return ['wildlife'];
      case POI.Waterfall: return ['waterfall'];
      case POI.Warning: return ['warning'];
      default: throw Error('Invalid POI type for serverType: ' + this.poi);
    }
  }


  /**
     * Returns the relative path for the MVT based on whether the POI is an accommodation or an amenity.
     */
    mvtPath() {
        if (this.isAccommodation()) {
            return 'get_accommodations_mvt';
        } else {
            return 'get_amenities_mvt';
        }
    }

    /**
     * Computes the full MVT URL.
     */
    computeMvtUrl(): string {
        return `${window.location.origin}/vector/${this.mvtPath()}/{z}/{x}/{y}?type=${this.serverType()}`;
    }

    computePuckIconName(): string {
      return `puck_icon_${this.serverType()}`;
    }

    previewImage(): string {
        switch (this.poi) {
            case POI.Campground:
                return placeholder_campground;
            case POI.Hotel:
                return placeholder_hotel;
            case POI.Hostel:
                return placeholder_hostel;
            case POI.BnB:
                return placeholder_bnb;
            case POI.Motel:
                return placeholder_bnb;
            case POI.OSMCampsites:
                return placeholder_osmCampsite;
            case POI.Shelter:
                return placeholder_shelter;
            case POI.Pub:
                return placeholder_pub;
            case POI.FastFood:
                return placeholder_fast_food;
            case POI.Viewpoint:
                return placeholder_viewpoint;
            case POI.TransportStation:
                return placeholder_transport;
            case POI.Shop:
                return placeholder_shop;
            case POI.Town:
                return placeholder_town;
            case POI.History:
                return placeholder_history;
            case POI.BusStop:
                return placeholder_bus_stop;
            case POI.PostOffice:
                return placeholder_postOffice;
            case POI.Peak:
                return placeholder_peak;
            case POI.Pharmacy:
                return placeholder_pharmacy;
            case POI.Water:
                return placeholder_water;
            case POI.Healthcare:
                return placeholder_healthcare;
            case POI.Restaurant:
                return placeholder_restaurant;
            default:
                return highlight_town;
        }
    }

    highlightImage() {
        switch (this.poi) {
            case POI.Campground:
                return highlight_campground;
            case POI.Hotel:
                return highlight_hotel;
            case POI.Hostel:
                return highlight_hostel;
            case POI.BnB:
                return highlight_bnb;
            case POI.Motel:
                return highlight_hotel;
            case POI.OSMCampsites:
                return highlight_osmCampsite;
            case POI.Shelter:
                return highlight_shelter;
            case POI.Pub:
                return highlight_pub;
            case POI.FastFood:
                return highlight_fast_food;
            case POI.Viewpoint:
                return highlight_viewpoint;
            case POI.TransportStation:
                return highlight_transport;
            case POI.Shop:
                return highlight_shop;
            case POI.Town:
                return highlight_town;
            case POI.History:
                return highlight_history;
            case POI.BusStop:
                return highlight_bus_stop;
            case POI.PostOffice:
                return highlight_postOffice;
            case POI.Peak:
                return highlight_peak;
            case POI.Pharmacy:
                return highlight_pharmacy;
            case POI.Water:
                return highlight_water;
            case POI.Healthcare:
                return highlight_healthcare;
            case POI.Restaurant:
                return highlight_restaurant;
            default:
                return highlight_town;
        }
    }

    private getCategory() {
        switch (this.poi) {
            case POI.Campground:
            case POI.Hotel:
            case POI.Hostel:
            case POI.BnB:
            case POI.Motel:
                return 'accommodations';
            default:
                return 'amenities';
        }
    }

    databaseClassName() {
        switch (this.poi) {
            case POI.Campground:
            case POI.Hotel:
            case POI.Hostel:
            case POI.BnB:
            case POI.Motel:
                return 'Accommodation';
            default:
                return 'Amenity';
        }
    }

    get(trailUrl: string): Promise<any> {
        return axios_client.get(trailUrl + `/${this.getCategory()}.json?type=${this.poi}`);
    }

    getColor() {
        switch (this.poi) {
            case POI.Hotel:
                return "#E45D5D";
            case POI.Hostel:
                return "#A14DAF";
            case POI.BnB:
                return "#F57700";
            case POI.Campground:
                return "#70C381";
            case POI.Motel:
                return "#BAD033";
            case POI.BusStop:
                return "#2B87CA";
            case POI.FastFood:
                return "#FFC107";
            case POI.Healthcare:
                return "#E45D5D";
            case POI.OSMCampsites:
                return "#2CC2E3";
            case POI.Peak:
                return "#BAD033";
            case POI.Pharmacy:
                return "#BAD033";
            case POI.Pub:
                return "#2B87CA";
            case POI.Restaurant:
                return "#FFC107";
            case POI.Shelter:
                return "#FFC107";
            case POI.Shop:
                return "#70C381";
            case POI.Town:
                return "#A14DAF";
            case POI.TransportStation:
                return "#2B87CA";
            case POI.Viewpoint:
                return "#2CC2E3";
            case POI.Water:
                return "#2CC2E3";
            case POI.History:
                return "#F57700";
            case POI.PostOffice:
                return "#F57700";
            case POI.Cave:
                return "#A14DAF";
            case POI.Coffee:
                return "#70C381";
            case POI.EVCharging:
                return "#FDDF00";
            case POI.Gate:
                return "#A14DAF";
            case POI.Information:
                return "#FDDF00";
            case POI.Junction:
                return "#2CC2E3";
            case POI.Parking:
                return "#2B87CA";
            case POI.Picnic:
                return "#F57700";
            case POI.Playground:
                return "#A14DAF";
            case POI.Restroom:
                return "#E45D5D";
            case POI.Storage:
                return "#E45D5D";
            case POI.Swimming:
                return "#2CC2E3";
            case POI.Wifi:
                return "#70C381";
            case POI.Wildlife:
                return "#F57700";
            case POI.Waterfall:
                return "#2B87CA";
            case POI.Warning:
                return "#E45D5D";
        }
    }

    getPublicImageIcon() {
        switch (this.poi) {
            case POI.Campground:
                return icon_campground;
            case POI.Hotel:
                return icon_hotel;
            case POI.Hostel:
                return icon_hostel;
            case POI.BnB:
                return icon_bnb;
            case POI.Motel:
                return icon_motel;
            case POI.OSMCampsites:
                return icon_campground;
            case POI.Shelter:
                return icon_shelter;
            case POI.Pub:
                return icon_pub;
            case POI.FastFood:
                return icon_fast_food;
            case POI.Viewpoint:
                return icon_viewpoint;
            case POI.TransportStation:
                return icon_bus;
            case POI.Shop:
                return icon_shop;
            case POI.Town:
                return icon_town;
            case POI.History:
                return icon_history;
            case POI.BusStop:
                return icon_bus;
            case POI.PostOffice:
                return icon_post_office;
            case POI.Peak:
                return icon_peak;
            case POI.Pharmacy:
                return icon_pharmacy;
            case POI.Water:
                return icon_water;
            case POI.Healthcare:
                return icon_medical;
            case POI.Restaurant:
                return icon_fast_food;
            case POI.Other:
                return icon_information;
            case POI.Cave:
                return icon_cave;
            case POI.Coffee:
                return icon_coffee;
            case POI.EVCharging:
                return icon_ev_charging;
            case POI.Gate:
                return icon_gate;
            case POI.Information:
                return icon_information;
            case POI.Junction:
                return icon_junction;
            case POI.Parking:
                return icon_parking;
            case POI.Picnic:
                return icon_picnic;
            case POI.Playground:
                return icon_playground;
            case POI.Restroom:
                return icon_restroom;
            case POI.Storage:
                return icon_storage;
            case POI.Swimming:
                return icon_swimming;
            case POI.Wifi:
                return icon_wifi;
            case POI.Wildlife:
                return icon_wildlife;
            case POI.Waterfall:
                return icon_waterfall;
            case POI.Warning:
                return icon_warning;
            default:
                throw Error('Invalid POI');
        }
    }

    getSpriteSheetIcon() {
        switch (this.poi) {
            case POI.Campground:
                return 'poi_icon_campground';
            case POI.Hotel:
                return 'poi_icon_hotel';
            case POI.Hostel:
                return 'poi_icon_hostel';
            case POI.BnB:
                return 'poi_icon_bnb';
            case POI.Motel:
                return 'poi_icon_motel';
            case POI.OSMCampsites:
                return 'poi_icon_campground';
            case POI.Shelter:
                return 'poi_icon_shelter';
            case POI.Pub:
                return 'poi_icon_pub';
            case POI.FastFood:
                return 'poi_icon_fast_food';
            case POI.Viewpoint:
                return 'poi_icon_viewpoint';
            case POI.TransportStation:
                return 'poi_icon_bus';
            case POI.Shop:
                return 'poi_icon_shop';
            case POI.Town:
                return 'poi_icon_town';
            case POI.History:
                return 'poi_icon_history';
            case POI.PostOffice:
                return 'poi_icon_post_office';
            case POI.BusStop:
                return 'poi_icon_bus';
            case POI.Peak:
                return 'poi_icon_peak';
            case POI.Pharmacy:
                return 'poi_icon_pharmacy';
            case POI.Water:
                return 'poi_icon_water';
            case POI.Healthcare:
                return 'poi_icon_medical';
            case POI.Restaurant:
                return 'poi_icon_fast_food';
            case POI.Other:
                return 'poi_icon_custom';
            case POI.Cave:
                return 'poi_icon_cave';
            case POI.Coffee:
                return 'poi_icon_coffee';
            case POI.EVCharging:
                return 'poi_icon_ev_charging';
            case POI.Gate:
                return 'poi_icon_gate';
            case POI.Information:
                return 'poi_icon_information';
            case POI.Junction:
                return 'poi_icon_junction';
            case POI.Parking:
                return 'poi_icon_parking';
            case POI.Picnic:
                return 'poi_icon_picnic';
            case POI.Playground:
                return 'poi_icon_playground';
            case POI.Restroom:
                return 'poi_icon_restroom';
            case POI.Storage:
                return 'poi_icon_storage';
            case POI.Swimming:
                return 'poi_icon_swimming';
            case POI.Wifi:
                return 'poi_icon_wifi';
            case POI.Wildlife:
                return 'poi_icon_wildlife';
            case POI.Waterfall:
                return 'poi_icon_waterfall';
            case POI.Warning:
                return 'poi_icon_warning';
            default:
                throw Error('Invalid POI');
        }
    }

    getSpriteSheetWaypointIcon() {
        return 'custom_waypoint_icon_' + this.serverType();
    }

    static accoms(trail: any | null): POIUtility[] {
        if (trail != null) {
            const poiToReturn: POIUtility[] = [];
            if (trail.campgroundCount > 0) {
                poiToReturn.push(new POIUtility(POI.Campground));
            }
            if (trail.hotelCount > 0) {
                poiToReturn.push(new POIUtility(POI.Hotel));
            }
            if (trail.hostelCount > 0) {
                poiToReturn.push(new POIUtility(POI.Hostel));
            }
            if (trail.bnbCount > 0) {
                poiToReturn.push(new POIUtility(POI.BnB));
            }
            if (trail.motelCount > 0) {
                poiToReturn.push(new POIUtility(POI.Motel));
            }
            return poiToReturn;
        }
        return [
            new POIUtility(POI.Campground),
            new POIUtility(POI.Hotel),
            new POIUtility(POI.Hostel),
            new POIUtility(POI.BnB),
            new POIUtility(POI.Motel),
        ];
    }

    static amenities(trail: any | null): POIUtility[] {
        if (trail != null) {
            const poiToReturn: POIUtility[] = [];
            if (trail.osmcampsiteCount > 0) {
                poiToReturn.push(new POIUtility(POI.OSMCampsites));
            }
            if (trail.shelterCount > 0) {
                poiToReturn.push(new POIUtility(POI.Shelter));
            }
            if (trail.pubCount > 0) {
                poiToReturn.push(new POIUtility(POI.Pub));
            }
            if (trail.fastfoodCount > 0) {
                poiToReturn.push(new POIUtility(POI.FastFood));
            }
            if (trail.viewpointCount > 0) {
                poiToReturn.push(new POIUtility(POI.Viewpoint));
            }
            if (trail.transportStationCount > 0) {
                poiToReturn.push(new POIUtility(POI.TransportStation));
            }
            if (trail.shopCount > 0) {
                poiToReturn.push(new POIUtility(POI.Shop));
            }
            if (trail.townCount > 0) {
                poiToReturn.push(new POIUtility(POI.Town));
            }
            if (trail.historyCount > 0) {
                poiToReturn.push(new POIUtility(POI.History));
            }
            if (trail.busStopCount > 0) {
                poiToReturn.push(new POIUtility(POI.BusStop));
            }
            if (trail.postOfficeCount > 0) {
                poiToReturn.push(new POIUtility(POI.PostOffice));
            }
            if (trail.peakCount > 0) {
                poiToReturn.push(new POIUtility(POI.Peak));
            }
            if (trail.pharmacyCount > 0) {
                poiToReturn.push(new POIUtility(POI.Pharmacy));
            }
            if (trail.waterCount > 0) {
                poiToReturn.push(new POIUtility(POI.Water));
            }
            if (trail.healthcareCount > 0) {
                poiToReturn.push(new POIUtility(POI.Healthcare));
            }
            if (trail.restaurantCount > 0) {
                poiToReturn.push(new POIUtility(POI.Restaurant));
            }
            if (trail.caveCount > 0) {
                poiToReturn.push(new POIUtility(POI.Cave));
            }
            if (trail.coffeeCount > 0) {
                poiToReturn.push(new POIUtility(POI.Coffee));
            }
            if (trail.evChargingCount > 0) {
                poiToReturn.push(new POIUtility(POI.EVCharging));
            }
            if (trail.gateCount > 0) {
                poiToReturn.push(new POIUtility(POI.Gate));
            }
            if (trail.informationCount > 0) {
                poiToReturn.push(new POIUtility(POI.Information));
            }
            if (trail.junctionCount > 0) {
                poiToReturn.push(new POIUtility(POI.Junction));
            }
            if (trail.parkingCount > 0) {
                poiToReturn.push(new POIUtility(POI.Parking));
            }
            if (trail.picnicCount > 0) {
                poiToReturn.push(new POIUtility(POI.Picnic));
            }
            if (trail.playgroundCount > 0) {
                poiToReturn.push(new POIUtility(POI.Playground));
            }
            if (trail.restroomCount > 0) {
                poiToReturn.push(new POIUtility(POI.Restroom));
            }
            if (trail.storageCount > 0) {
                poiToReturn.push(new POIUtility(POI.Storage));
            }
            if (trail.swimmingCount > 0) {
                poiToReturn.push(new POIUtility(POI.Swimming));
            }
            if (trail.wifiCount > 0) {
                poiToReturn.push(new POIUtility(POI.Wifi));
            }
            if (trail.wildlifeCount > 0) {
                poiToReturn.push(new POIUtility(POI.Wildlife));
            }
            if (trail.waterfallCount > 0) {
                poiToReturn.push(new POIUtility(POI.Waterfall));
            }
            if (trail.warningCount > 0) {
                poiToReturn.push(new POIUtility(POI.Warning));
            }
            return poiToReturn;
        }
        return [
            new POIUtility(POI.OSMCampsites),
            new POIUtility(POI.Shelter),
            new POIUtility(POI.Pub),
            new POIUtility(POI.FastFood),
            new POIUtility(POI.Viewpoint),
            new POIUtility(POI.TransportStation),
            new POIUtility(POI.Shop),
            new POIUtility(POI.Town),
            new POIUtility(POI.History),
            new POIUtility(POI.BusStop),
            new POIUtility(POI.PostOffice),
            new POIUtility(POI.Peak),
            new POIUtility(POI.Pharmacy),
            new POIUtility(POI.Water),
            new POIUtility(POI.Healthcare),
            new POIUtility(POI.Restaurant),
            new POIUtility(POI.Cave),
            new POIUtility(POI.Coffee),
            new POIUtility(POI.EVCharging),
            new POIUtility(POI.Gate),
            new POIUtility(POI.Information),
            new POIUtility(POI.Junction),
            new POIUtility(POI.Parking),
            new POIUtility(POI.Picnic),
            new POIUtility(POI.Playground),
            new POIUtility(POI.Restroom),
            new POIUtility(POI.Storage),
            new POIUtility(POI.Swimming),
            new POIUtility(POI.Wifi),
            new POIUtility(POI.Wildlife),
            new POIUtility(POI.Waterfall),
            new POIUtility(POI.Warning)
        ];
    }

  static allParkUtils(): POIUtility[] {
    return [
      new POIUtility(POI.Campground),
      new POIUtility(POI.OSMCampsites),
      new POIUtility(POI.Shelter),
      new POIUtility(POI.Viewpoint),
      new POIUtility(POI.History),
      new POIUtility(POI.BusStop),
      new POIUtility(POI.Peak),
      new POIUtility(POI.Water),
      new POIUtility(POI.Restaurant),
      new POIUtility(POI.Coffee),
      new POIUtility(POI.EVCharging),
      new POIUtility(POI.Gate),
      new POIUtility(POI.Information),
      new POIUtility(POI.Junction),
      new POIUtility(POI.Parking),
      new POIUtility(POI.Picnic),
      new POIUtility(POI.Playground),
      new POIUtility(POI.Restroom),
      new POIUtility(POI.Swimming),
      new POIUtility(POI.Wifi),
      new POIUtility(POI.Wildlife),
      new POIUtility(POI.Waterfall),
      new POIUtility(POI.Warning)
    ];
  }

    static allPOIUtils(): POIUtility[] {
        return [
            new POIUtility(POI.Campground),
            new POIUtility(POI.Hotel),
            new POIUtility(POI.Hostel),
            new POIUtility(POI.BnB),
            new POIUtility(POI.Motel),
            new POIUtility(POI.OSMCampsites),
            new POIUtility(POI.Shelter),
            new POIUtility(POI.Pub),
            new POIUtility(POI.FastFood),
            new POIUtility(POI.Viewpoint),
            new POIUtility(POI.TransportStation),
            new POIUtility(POI.Shop),
            new POIUtility(POI.Town),
            new POIUtility(POI.History),
            new POIUtility(POI.BusStop),
            new POIUtility(POI.PostOffice),
            new POIUtility(POI.Peak),
            new POIUtility(POI.Pharmacy),
            new POIUtility(POI.Water),
            new POIUtility(POI.Healthcare),
            new POIUtility(POI.Restaurant),
            new POIUtility(POI.Other),
            new POIUtility(POI.Cave),
            new POIUtility(POI.Coffee),
            new POIUtility(POI.EVCharging),
            new POIUtility(POI.Gate),
            new POIUtility(POI.Information),
            new POIUtility(POI.Junction),
            new POIUtility(POI.Parking),
            new POIUtility(POI.Picnic),
            new POIUtility(POI.Playground),
            new POIUtility(POI.Restroom),
            new POIUtility(POI.Storage),
            new POIUtility(POI.Swimming),
            new POIUtility(POI.Wifi),
            new POIUtility(POI.Wildlife),
            new POIUtility(POI.Waterfall),
            new POIUtility(POI.Warning)
        ];
    }

    static checkForPassedPOIs(): POIUtility[] {
        const urlParams = new URLSearchParams(window.location.search);

        const dedupeAndAppend = (collection: POIUtility[], additions: POIUtility[]) => {
            additions.forEach((poi) => {
                if (!collection.some((existing) => existing.serverType() === poi.serverType())) {
                    collection.push(poi);
                }
            });
        };

        const parseCategoryParam = (
            param: string | null,
            categoryFilter: (poi: POIUtility) => boolean
        ): POIUtility[] => {
            if (!param) {
                return [];
            }

            const tokens = param.split(',').map((token) => token.trim()).filter(Boolean);
            const parsed: POIUtility[] = [];

            tokens.forEach((token) => {
                const normalizedToken = token.toLowerCase();

                if (normalizedToken === 'all' || normalizedToken === 'true' || normalizedToken === '1') {
                    parsed.push(...POIUtility.allPOIUtils().filter((poi) => categoryFilter(poi)));
                    return;
                }

                try {
                    const poi = POIUtility.fromString(token);
                    if (categoryFilter(poi)) {
                        parsed.push(poi);
                    }
                } catch (error) {
                    console.warn('Invalid POI passed via query param:', token, error);
                }
            });

            return parsed;
        };

        const passedPois: POIUtility[] = [];
        dedupeAndAppend(
            passedPois,
            parseCategoryParam(
                urlParams.get('accommodations'),
                (poi) => poi.isAccommodation()
            )
        );
        dedupeAndAppend(
            passedPois,
            parseCategoryParam(
                urlParams.get('amenities'),
                (poi) => poi.isAmenity()
            )
        );

        return passedPois;
    }

    /**
     * Converts a string into a POIUtility instance.
     * Note: The mvtUrl property is set in the constructor.
     */
    static fromString(poi: string): POIUtility {
        switch (poi) {
            case 'campground':
                return new POIUtility(POI.Campground);
            case 'hotel':
                return new POIUtility(POI.Hotel);
            case 'hostel':
                return new POIUtility(POI.Hostel);
            case 'bnb':
                return new POIUtility(POI.BnB);
            case 'motel':
                return new POIUtility(POI.Motel);
            case 'osmcampsite':
            case 'osmCampsite':
                return new POIUtility(POI.OSMCampsites);
            case 'shelter':
                return new POIUtility(POI.Shelter);
            case 'pub':
                return new POIUtility(POI.Pub);
            case 'fast-food':
            case 'fastfood':
                return new POIUtility(POI.FastFood);
            case 'viewpoint':
                return new POIUtility(POI.Viewpoint);
            case 'transportStation':
            case 'transport-station':
            case 'transport_station':
            case 'transportStations':
                return new POIUtility(POI.TransportStation);
            case 'shop':
                return new POIUtility(POI.Shop);
            case 'town':
                return new POIUtility(POI.Town);
            case 'history':
                return new POIUtility(POI.History);
            case 'bus-stop':
            case 'bus_stop':
            case 'busStops':
                return new POIUtility(POI.BusStop);
            case 'post-office':
            case 'post_office':
            case 'postOffice':
                return new POIUtility(POI.PostOffice);
            case 'peak':
            case 'peaks':
                return new POIUtility(POI.Peak);
            case 'pharmacy':
                return new POIUtility(POI.Pharmacy);
            case 'water':
                return new POIUtility(POI.Water);
            case 'healthcare':
                return new POIUtility(POI.Healthcare);
            case 'restaurant':
                return new POIUtility(POI.Restaurant);
            case 'other':
                return new POIUtility(POI.Other);
            case 'cave':
                return new POIUtility(POI.Cave);
            case 'coffee':
                return new POIUtility(POI.Coffee);
            case 'ev-charging':
            case 'evCharging':
            case 'ev_charging':
                return new POIUtility(POI.EVCharging);
            case 'gate':
                return new POIUtility(POI.Gate);
            case 'information':
                return new POIUtility(POI.Information);
            case 'junction':
                return new POIUtility(POI.Junction);
            case 'parking':
                return new POIUtility(POI.Parking);
            case 'picnic':
                return new POIUtility(POI.Picnic);
            case 'playground':
                return new POIUtility(POI.Playground);
            case 'restroom':
                return new POIUtility(POI.Restroom);
            case 'storage':
                return new POIUtility(POI.Storage);
            case 'swimming':
                return new POIUtility(POI.Swimming);
            case 'wifi':
                return new POIUtility(POI.Wifi);
            case 'wildlife':
                return new POIUtility(POI.Wildlife);
            case 'waterfall':
                return new POIUtility(POI.Waterfall);
            case 'warning':
                return new POIUtility(POI.Warning);
        }
        const poiUtility = POIUtility.allPOIUtils().find(
            (poiToCheck) => poiToCheck.englishName() === poi || poiToCheck.serverType() === poi || poiToCheck.mapboxFilterType() === poi
        );
        if (poiUtility) {
            return poiUtility;
        }
        throw Error('Invalid POI of type ' + poi);
    }

    isAccommodation(): boolean {
        return this.getCategory() === 'accommodations';
    }

    isAmenity(): boolean {
        return this.getCategory() === 'amenities';
    }
}
